import React from "react";
import "./Education.css";

function Education() {
  return (
    <section className="education-timeline-section page reveal delay-1" id="education">
      <h1 className="journey-title">
        My <span>Journey</span>
      </h1>

      <h2 className="edu-heading">Education</h2>

      <div className="timeline">

        <div className="timeline-item reveal delay-1">
          <span className="timeline-dot"></span>
          <div className="timeline-card">
            <span className="timeline-year">2019 – 2020</span>
            <h3>SSLC (10th) – 82.9%</h3>
            <p>Thirumathi R.Valliammai achi Hign school, Pattamangalam</p>
          </div>
        </div>

        <div className="timeline-item reveal delay-2">
          <span className="timeline-dot"></span>
          <div className="timeline-card">
            <span className="timeline-year">2020 – 2022</span>
            <h3>HSC – 81.6%</h3>
            <p>Sethu Irani Higher secontary School, Kandramanickam</p>
          </div>
        </div>

        <div className="timeline-item reveal delay-3">
          <span className="timeline-dot"></span>
          <div className="timeline-card">
            <span className="timeline-year">2022 – 2025</span>
            <h3>B.Sc Information Technology – 78.5</h3>
            <p>Alagappa University</p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Education;
